import React, { useEffect, useMemo, useState } from "react";
import * as Styled from "./styles";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ArrowBack as ArrowBackIcon,
  FilterList as FilterListIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ScheduledOrderCard } from "./components/ScheduledOrderCard";
import RightSideMenu from "components/RightSideMenu";
import ResellerFilter from "components/ResellerFilter";
import { handleGetScheduledCheckoutItemsRequest } from "store/modules/Checkout/thunk.store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { RootState } from "store/index";
import { CheckoutItemDataProps } from "store/modules/Checkout/types.store";

const ScheduleOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedReseller, setSelectedReseller] = useState<any>(null);

  const scheduledCheckoutItems: CheckoutItemDataProps[] = useAppSelector(
    (state: RootState) => state.checkout.scheduledCheckoutItems,
  );

  const pagination = useAppSelector(
    (state: RootState) => state.checkout.scheduledCheckoutItemsPagination,
  );

  const filteredCheckoutItems: CheckoutItemDataProps[] = useMemo(() => {
    const items = Array.isArray(scheduledCheckoutItems)
      ? scheduledCheckoutItems
      : [];
    if (selectedReseller) {
      return items.filter((item) => item.dealer.id === selectedReseller.id);
    }
    return items;
  }, [scheduledCheckoutItems, selectedReseller]);

  const handleShowSideMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleApplyFilter = (reseller: any) => {
    setSelectedReseller(reseller);
    setIsMenuOpen(false);
  };

  const handleLoadMoreScheduledOrders = () => {
    if (selectedReseller) {
      dispatch(
        handleGetScheduledCheckoutItemsRequest({
          dealerId: selectedReseller.id,
          pagination: {
            limit: 10,
            keyset: pagination.keyset || null,
          },
        }),
      );
    }
  };

  useEffect(() => {
    if (selectedReseller) {
      dispatch(
        handleGetScheduledCheckoutItemsRequest({
          dealerId: selectedReseller.id,
          pagination: {
            limit: 10,
            keyset: null,
          },
        }),
      );
    }
  }, [dispatch, selectedReseller]);

  return (
    <Styled.Container>
      <Styled.ContainerButton>
        <Button
          onClick={() => navigate("/orders/manage")}
          color="inherit"
          variant="text"
        >
          <ArrowBackIcon />
          {t("back")}
        </Button>
      </Styled.ContainerButton>
      <Typography variant="body1">{t("scheduledOrdersDescription")}</Typography>
      <Styled.CardContainer>
        <Typography variant="h6">{t("scheduledOrdersTitle")}</Typography>
        <Button variant="text" color="primary" onClick={handleShowSideMenu}>
          <FilterListIcon />
          <Typography variant="body1" style={{ marginLeft: 8 }}>
            {t("filter")}
          </Typography>
        </Button>
      </Styled.CardContainer>

      {filteredCheckoutItems.length > 0
        ? filteredCheckoutItems.map((item) => (
            <ScheduledOrderCard key={item.id} item={item} />
          ))
        : selectedReseller && (
            <Styled.CardContainer>
              <Typography variant="body1" color="text.secondary" align="center">
                Nenhum agendamento encontrado para a revenda selecionada.
              </Typography>
            </Styled.CardContainer>
          )}
      {selectedReseller && (
        <Button
          variant="text"
          color="primary"
          onClick={handleLoadMoreScheduledOrders}
        >
          Carregar mais
        </Button>
      )}
      <RightSideMenu isOpen={isMenuOpen} onClose={handleShowSideMenu}>
        <ResellerFilter onApplyFilter={handleApplyFilter} />
      </RightSideMenu>
    </Styled.Container>
  );
};

export default ScheduleOrders;
